import './LoaderPrecios.css';

const LoaderPrecios = () => {

    return (
        <div class="spinner"></div>
    )
}

export default LoaderPrecios;